import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { Icon20 } from 'builder/components/Icon'
import Typography, { FontWeights } from 'builder/styles/typography'

import { WidgetImage } from '../../widget.styles'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
`

export const Box = styled.div`
  flex: 1;
`

export const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  padding: 12px;
  border-radius: 8px;
  border: 1px solid ${Colors.Neutral15};
  background: ${Colors.White};
`

export const ActionText = styled.p`
  ${Typography.Body}
  ${FontWeights.Regular}

  color: ${Colors.Neutral90};
`

export const CompletedContainer = styled.div`
  width: 100%;
  height: 100%;
  gap: 12px;
  display: flex;
  padding: 36px 48px;
  justify-content: space-between;
`

export const Image = styled(WidgetImage)``

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`

export const Icon = styled(Icon20.ChevronRightRegular)`
  color: ${Colors.Neutral80};
`
